export default __webpack_public_path__ + "static/media/product-3.456d4cea.jpg";